import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OptionTemplateDirective } from '../data-source-utils/option-template.directive';
import { FormInputDirective } from './form-input.directive';
import { FormLabelDirective } from './form-label.directive';
import { FormValidationMessageDirective } from './form-validation-message.directive';
import { StopPropagationDirective } from './stop-propagation.directive';



@NgModule({
  declarations: [

    FormLabelDirective,
    FormValidationMessageDirective,
    OptionTemplateDirective,
    FormInputDirective,
    StopPropagationDirective
  ],
  exports: [

    FormLabelDirective,
    FormValidationMessageDirective,
    OptionTemplateDirective,
    FormInputDirective,
    StopPropagationDirective
  ],
  imports: [
    CommonModule,

    MatFormFieldModule
  ]
})
export class FormControlsUtilsModule { }
